export function useClampTabControl(clampedRef) {
  const clampedElement = clampedRef.value;
  if (!clampedElement) return;
  const links = clampedElement.querySelectorAll('a');
  links.forEach((link) => {
    const linkRect = link.getBoundingClientRect();
    const parentRect = clampedElement.getBoundingClientRect();
    const isVisible =
      linkRect.top >= parentRect.top && linkRect.bottom <= parentRect.bottom;
    link.tabIndex = isVisible ? '0' : '-1';
  });
}
